<template>
  <v-row class="mt-2">
    <v-col cols="12" class="ticket-container" v-for="ticket in concert.tickets" :key="ticket.sipl_platznr"
      :data-ticket-id="ticket.qr_access_code">
      <v-alert v-if="!canPrint" type="warning" icon="mdi-alert">{{ properties.policy_2.message }}</v-alert>
      <v-card flat outlined class="d-flex flex-column flex-md-row px-5 py-5 print__card">

        <div>
          <qrcode-vue v-if="canPrint && ticket.qr_access_code" :value="ticket.qr_access_code" size="250" level="H" class="mr-5 mb-5 mb-md-0 print__qr"></qrcode-vue>
          <v-alert v-if="canPrint && !ticket.qr_access_code" type="warning" icon="mdi-alert" style="max-width: 200px;">QR-Code konnte nicht erzeugt werden. Bitte kontaktieren Sie das Ticket- und Servicecenter.</v-alert>
          <p class="mb-5 mr-5 text-center">Ku.Nr: {{ customerData.kunden_nr }}</p>
        </div>
        <div class="ml-0 ml-md-5 print__content flex-grow-1">
          <div class="d-flex justify-space-between">
            <p class="subtitle text-left">Vorst.Nr: {{ concert.konzertdaten.vorst_nr }}</p>
            <p class="subtitle text-right"
              v-if="concert.konzertdaten.eventdata.comment_customer_marked_id && concert.konzertdaten.eventdata.comment_customer_marked_id !== 'null'">
              Info: {{ concert.konzertdaten.eventdata.comment_customer_marked_id }}
            </p>
          </div>
          <p>
            <span class="text-h5">{{ concert.konzertdaten.eventdata.name }}</span>
            <br v-if="concert.konzertdaten.zyklus_name">
            <span>{{ concert.konzertdaten.zyklus_name }}</span>
          </p>
          <p class="text-h6">{{ concert.konzertdaten.vorst_datum_text }}</p>
          <p class="text-h5 mb-0 font-weight-bold" v-if="concert.konzertdaten.eventdata.venue">{{
      concert.konzertdaten.eventdata.venue.name }}</p>
          <!-- <p class="mb-5">Wiener Konzerthaus, 1030 Wien, Lothringerstraße 20</p> -->
          <!-- Venues are not static anymore, derives from server -->
          <p class="mb-5" v-if="concert.konzertdaten.eventdata.venue">{{ concert.konzertdaten.eventdata.venue.location
            }}, {{ concert.konzertdaten.eventdata.venue.cap }} {{ concert.konzertdaten.eventdata.venue.city }}, {{
      concert.konzertdaten.eventdata.venue.street }}</p>
          <hr class="mb-5" style="border-top: 1px solid #eee; max-width: 340px;">
          <div v-if="!concert.konzertdaten.eventdata.alter_seat &&
      ticket.apos_katnr !== 9 &&
      ticket.apos_katnr !== 12 &&
      ticket.apos_katnr !== 13 &&
      ticket.apos_katnr !== 14 &&
      ticket.apos_katnr !== 15 &&
      ticket.apos_katnr !== 19 &&
      ticket.apos_katnr !== 20 &&
      ticket.apos_katnr !== 21 &&
      ticket.apos_katnr !== 22 &&
      ticket.sektor_name1 !== 'Podium' &&
      ticket.sektor_name1 !== 'Podiumsitze'">
            <div class="d-flex align-baseline">
              <p class="text-h5 font-weight-bold mr-3">{{ ticket.sektor_name1 }} {{ ticket.sektor_name2 }}</p>
              <span class="mr-2" v-if="ticket.sipl_reihennr">Reihe</span>
              <p class="text-h5 font-weight-bold mr-3" v-if="ticket.sipl_reihennr">{{ ticket.sipl_reihennr }}</p>
              <span class="mr-2">Platz</span>
              <p class="text-h5 font-weight-bold mr-3">{{ ticket.sipl_platznr }}</p>
            </div>
          </div>
          <div v-if="concert.konzertdaten.eventdata.alter_seat !== 'null'" class="mb-5">
            <p class="text-h5 mb-5">{{ concert.konzertdaten.vorst_alternative_sitzplatzinfo }}</p>
          </div>
          <div v-if="(ticket.sektor_name1 === 'Podium' || ticket.sektor_name1 === 'Podiumsitze') && (concert.konzertdaten.eventdata.alter_seat === null || concert.konzertdaten.eventdata.alter_seat === 'null' || concert.konzertdaten.eventdata.alter_seat === '') &&
      ticket.apos_katnr !== 9 &&
      ticket.apos_katnr !== 12 &&
      ticket.apos_katnr !== 13 &&
      ticket.apos_katnr !== 14 &&
      ticket.apos_katnr !== 15 &&
      ticket.apos_katnr !== 19 &&
      ticket.apos_katnr !== 20 &&
      ticket.apos_katnr !== 21 &&
      ticket.apos_katnr !== 22" class="mb-5">
            <p class="text-h6 font-weight-bold mb-5">1 Platz Podium {{ ticket.sektor_name2 }} (Freie Platzwahl)</p>
          </div>
          <div
            v-if="ticket.apos_katnr === 9 && (concert.konzertdaten.eventdata.alter_seat === null || concert.konzertdaten.eventdata.alter_seat === 'null' || concert.konzertdaten.eventdata.alter_seat === '')"
            class="mb-5">
            <p class="text-h5 font-weight-bold mb-5">1 Springerkarte</p>
          </div>
          <div
            v-if="ticket.apos_katnr === 12 && (concert.konzertdaten.eventdata.alter_seat === null || concert.konzertdaten.eventdata.alter_seat === 'null' || concert.konzertdaten.eventdata.alter_seat === '')"
            class="mb-5">
            <p class="text-h5 font-weight-bold mb-5">1 Stehplatz</p>
          </div>
          <div
            v-if="ticket.apos_katnr === 13 && (concert.konzertdaten.eventdata.alter_seat === null || concert.konzertdaten.eventdata.alter_seat === 'null' || concert.konzertdaten.eventdata.alter_seat === '')"
            class="mb-5">
            <p class="text-h5 font-weight-bold mb-5">1 »Im Klang«-Platz</p>
          </div>
          <div
            v-if="ticket.apos_katnr === 14 && (concert.konzertdaten.eventdata.alter_seat === null || concert.konzertdaten.eventdata.alter_seat === 'null' || concert.konzertdaten.eventdata.alter_seat === '')"
            class="mb-5">
            <p class="text-h5 font-weight-bold mb-5">1 Sitzplatz (Freie Platzwahl</p>
          </div>
          <div
            v-if="ticket.apos_katnr === 15 && (concert.konzertdaten.eventdata.alter_seat === null || concert.konzertdaten.eventdata.alter_seat === 'null' || concert.konzertdaten.eventdata.alter_seat === '')"
            class="mb-5">
            <p class="text-h5 font-weight-bold mb-5">1 Rollstuhlplatz</p>
          </div>
          <div
            v-if="ticket.apos_katnr === 19 && (concert.konzertdaten.eventdata.alter_seat === null || concert.konzertdaten.eventdata.alter_seat === 'null' || concert.konzertdaten.eventdata.alter_seat === '')"
            class="mb-5">
            <p class="text-h5 font-weight-bold mb-5">1 Karte Stage-Choir (Sopran)</p>
          </div>
          <div
            v-if="ticket.apos_katnr === 20 && (concert.konzertdaten.eventdata.alter_seat === null || concert.konzertdaten.eventdata.alter_seat === 'null' || concert.konzertdaten.eventdata.alter_seat === '')"
            class="mb-5">
            <p class="text-h5 font-weight-bold mb-5">1 Karte Stage-Choir (Alt)</p>
          </div>
          <div
            v-if="ticket.apos_katnr === 21 && (concert.konzertdaten.eventdata.alter_seat === null || concert.konzertdaten.eventdata.alter_seat === 'null' || concert.konzertdaten.eventdata.alter_seat === '')"
            class="mb-5">
            <p class="text-h5 font-weight-bold mb-5">1 Karte Stage-Choir (Tenor)</p>
          </div>
          <div
            v-if="ticket.apos_katnr === 22 && (concert.konzertdaten.eventdata.alter_seat === null || concert.konzertdaten.eventdata.alter_seat === 'null' || concert.konzertdaten.eventdata.alter_seat === '')"
            class="mb-5">
            <p class="text-h5 font-weight-bold mb-5">1 Karte Stage-Choir (Bass)</p>
          </div>
          <div v-if="ticket.preis">
            <p class="font-weight-bold">Preis {{ formatCurrency(ticket.preis) }}</p>
          </div>
          
        </div>
        <div class="d-flex flex-column justify-space-between">
          <div>
            <logo-template :template-key="templateKey" />
          </div>
          <v-btn dark @click="downloadTicket(ticket)" data-html2canvas-ignore="true" class="mt-8 download-ticket-button">
            <v-progress-circular indeterminate :size="16" :width="2" color="white" class="mr-4"
              v-if="generatingPDFStates[ticket.qr_access_code]"></v-progress-circular>
              <v-icon left>mdi-download</v-icon>
              Ticket herunterladen (PDF)
          </v-btn>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import QrcodeVue from "qrcode.vue";
import LogoTemplate from "@/components/LogoTemplate";
import propertyData from "@/assets/properties.json"
import { ticketDownloadMixin } from "@/mixins/ticketDownloadMixin";

export default {
  components: {
    QrcodeVue,
    LogoTemplate
  },
  props: {
    concertId: String
  },
  mixins: [ticketDownloadMixin],
  data: () => ({
    properties: propertyData,
    generatingPDFStates: {},
  }),
  computed: {
    templateKey() {
      return this.concert.konzertdaten.eventdata.customization?.key ?? process.env.VUE_APP_TICKET_TEMPLATE_DEFAULT
    },
    canPrint() {
      return this.concert.konzertdaten.eventdata.policy_id !== 2 &&
        this.concert.konzertdaten.eventdata.policy_id !== 3 &&
        this.concert.konzertdaten.eventdata.policy_id !== 4
    },
    concert() {
      return this.getConcertById(this.concertId)
    },
    ...mapGetters(["customerData", "getConcertById"]),
  },
  methods: {
    ...mapMutations(["addConcertToPrintByID"]),
    formatCurrency(value) {
      return 'EUR ' + new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    },
  },
  mounted() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  },
};
</script>

<style>
.print__qr {
  display: flex;
  justify-content: center;
}

.print__qr>canvas {
  width: 100px !important;
  height: 100px !important;
}

@media screen and (max-width: 992px) {
  .print__qr>canvas {
    width: 50% !important;
    height: 50% !important;
  }
}

@media print {
  .download-ticket-button {
    display: none;
  }
}

hr {
  border: none;
}
</style>
